'use client';

import { SidebarProvider } from '@efcloud/ef-fabric';
import { PropsWithChildren } from 'react';

const SidebarProviderWrapper = ({ children }: PropsWithChildren) => <SidebarProvider>{children}</SidebarProvider>;

export default SidebarProviderWrapper;
